import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NavigationProperty } from "../../decorators/EntityDecorators";
import { Account } from "../matwins-manager/Account.model";
import { PointOfService } from "./PointOfService.model";

export class i18nLanguage extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);;

  key!: string;

  @NavigationProperty({
    PropretyDisplayName: "Accounts",
    PropretyPluralName: "Accounts",
    ShowInTab: true,
    AddInplaceProprety: true,
    TargetType: Account
  })
  accounts?: Account[];

  //@NavigationProperty({
  //  PropretyDisplayName: "Point Of Services",
  //  PropretyPluralName: "Point Of Services",
  //  ShowInTab: true,
  //  AddInplaceProprety: true,
  //  TargetType: PointOfService
  //})
  pointOfServices?: PointOfService[];

  GetType(): IEntityMetaData {
    return i18nLanguage.getMetaData();
  }
}
